import CompanySettingsPage from "./general.page";

export default CompanySettingsPage;
